import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
  selector: 'app-area-mobile-filter',
  templateUrl: './area-mobile-filter.component.html',
  styleUrls: ['./area-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateDirective,
    FormsModule,
    InputText,
    ButtonDirective,
    TranslatePipe,
  ],
})
export class AreaMobileFilterComponent {
  readonly mobileFilterEvent = output<any>();

  name: string | null = null;
  region: string | null = null;
  owner: string | null = null;
  contactList: string | null = null;
  facilities: string | null = null;

  mobileFilter() {
    this.mobileFilterEvent.emit({
      name: this.name,
      region: this.region,
      owner: this.owner,
      contactList: this.contactList,
      facilities: this.facilities,
    });
  }

  clear() {
    this.name = null;
    this.region = null;
    this.owner = null;
    this.contactList = null;
    this.facilities = null;
    this.mobileFilter();
  }
}
